import type { BannerDtoType } from './banners.schema';
import { z } from 'zod';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { BannerDtoSchema } from './banners.schema';

export const bannersApi = {

  parseArray: (data: unknown) => z.array(BannerDtoSchema).parse(data),

  async getPublic() {
    const response = await httpClient.get<BannerDtoType[]>(
      ENDPOINTS.banners.public,
    );
    return bannersApi.parseArray(response);
  },

  async getUsersBanners() {
    const response = await httpClient.get<BannerDtoType[]>(
      ENDPOINTS.banners.usersBanners,
    );

    return bannersApi.parseArray(response);
  },
};
